import {
  RequestClient,
  RequestHeader,
  setAcceptLanguage,
} from '../../services/request';
import { SearchRequestProps } from './search.model';
import { publicConfig } from '../../services';
import { SuggestApiResponseModel, SuggestModel } from '../../models';
import { suggestResponseAdapter } from '../../adapters';

const API_SERVICE = '{{API_SERVICE}}';

export class SearchFormClient extends RequestClient<
  SearchRequestProps,
  SuggestApiResponseModel,
  SuggestModel
> {
  protected path = `${API_SERVICE}/v1/catalog/courses/suggest`;
  protected requestParameters: SearchRequestProps;
  protected adapter = suggestResponseAdapter;

  constructor(
    isB2B: boolean,
    params: SearchRequestProps,
    headers: RequestHeader
  ) {
    super(publicConfig.API_GATEWAY_URL, '', headers);
    this.requestParameters = params;
    this.path = this.path.replace(
      API_SERVICE,
      isB2B ? 'user-api' : 'course-api'
    );
  }
}

export const makeSearchRequest = (
  query: string,
  limit: number,
  isB2B = false,
  lang?: string,
  discountProgram?: string
): Promise<SuggestModel> => {
  const requestParams = {
    query,
    limit,
    lang,
    discount_program: discountProgram,
  };

  const headers = setAcceptLanguage(lang);

  return new SearchFormClient(
    isB2B,
    requestParams,
    headers
  ).get() as unknown as Promise<SuggestModel>;
};
